module.exports = require('./lib/refs');

module.exports.Collection = require('./lib/collection');